module.exports = __webpack_public_path__ + "static/media/10th.2299c59c.png";